import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isBoolean from "lodash/isBoolean";

const operationAccountApi = AiseaApiFactory.get("operationAccount");

class OperationAccountService {
  /**
   * 担当者一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationAccount[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  async getOperationAccounts() {
    return await operationAccountApi.index();
  }

  isOperationEnterpriseAccount(
    operationEnterpriseAccount // : OperationEnterpriseAccount
  ) {
    const oea = operationEnterpriseAccount;
    if (!isObject(oea)) return false;
    return (
      isString(oea.enterprise_account_id) &&
      isObject(oea.account) &&
      isString(oea.account.id) &&
      (oea.profile === null || isObject(oea.profile)) &&
      isString(oea.created_at) &&
      isString(oea.updated_at) &&
      (oea.deleted_at === null || isString(oea.deleted_at)) &&
      isBoolean(oea.free)
    );
  }

  // operationEnterpriseAccountがレポート一覧の検索に使用可能か判定
  isEnableToReportSearch(operationEnterpriseAccount) {
    const oea = operationEnterpriseAccount;
    if (!isObject(oea)) return false;
    return (
      isObject(oea.account) &&
      isString(oea.account.id) &&
      this.hasProfileName(oea.profile)
    );
  }

  hasProfileName(operationEnterpriseAccountProfile) {
    const oeaProfile = operationEnterpriseAccountProfile;
    if (!isObject(oeaProfile)) return false;
    return isString(oeaProfile.name);
  }
}

export default new OperationAccountService();
